export const heading = ['S.No', 'Prefix', 'Start Number', 'Suffix', 'Taxability', 'Preview', 'Action'];
export const addNewSetting = {
  prefix: '',
  nextinvoicenumber: '',
  suffix: '',
  taxability: 1,
};

export const isDefaultVoucherSeries = (series) => Number(series?.restrictedflag) === 1;

export const getTaxabilityForUpdate = (series, selectedTaxability) =>
  isDefaultVoucherSeries(series) ? Number(series?.taxability || 0) : Number(selectedTaxability || 0);
